// extracted by mini-css-extract-plugin
module.exports = {"layout":"_7a3fb80146--layout--tMgCM"};